// Identité de l'éditeur du site : source unique pour les mentions légales, les
// informations réglementaires, le pied de page et les données structurées.
// Ne renseigner que des informations vérifiées (Kbis, registre ORIAS) : un champ
// laissé vide n'est jamais affiché et la page indique qu'il est en cours de publication.
export const COMPANY = {
  brand: "Décennale Artisans",
  url: "https://decennale-artisans.com",
  // Ex. « Exemple Courtage SAS »
  legalName: "DA INSURANCE",
  // Ex. « SAS au capital de 1 000 € »
  legalForm: "",
  // Adresse complète du siège social
  address: "100 rue du Faubourg Saint-Honoré, 75008 Paris",
  siren: "",
  // Ex. « RCS Paris 123 456 789 »
  rcs: "",
  vat: "",
  publicationDirector: "",
  // Numéro ORIAS à 8 chiffres, vérifiable sur https://www.orias.fr
  orias: "",
  // Ex. « Courtier en assurance (COA) »
  oriasCategory: "",
  // Numéro affiché sur le site (sinon, variable REACT_APP_PHONE_NUMBER du build)
  phone: process.env.REACT_APP_PHONE_NUMBER || "",
  // Adresse e-mail publique de contact
  email: "",
  // Ex. « La Médiation de l'Assurance — www.mediation-assurance.org »
  mediator: "",
  host: {
    name: "Render Services, Inc.",
    address: "525 Brannan Street, Suite 300, San Francisco, CA 94107, États-Unis",
    url: "https://render.com",
  },
};

export const PENDING = "information en cours de publication";

export const telHref = (phone) => `tel:${phone.replace(/[^\d+]/g, "")}`;
